function formatCreatedAt(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}

export default function TemplatesTable({ templates, loading }) {
  return (
    <div>
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-900">Existing Templates</h2>
        <p className="text-sm text-gray-500 mt-0.5">
          Read-only list of notification templates.
        </p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="w-8 h-8 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin" />
          </div>
        ) : templates.length === 0 ? (
          <div className="py-20 text-center text-gray-400 text-sm">
            No templates yet. Create one above.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {["Name", "Marathi Title", "Odia Title", "Created At"].map((h) => (
                    <th
                      key={h}
                      className="px-3 sm:px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {templates.map((template) => (
                  <tr key={template.id || template.name} className="hover:bg-gray-50 transition-colors">
                    <td className="px-3 sm:px-4 py-3 text-sm font-medium text-gray-900 whitespace-nowrap font-mono">
                      {template.name || "—"}
                    </td>
                    <td className="px-3 sm:px-4 py-3 text-sm text-gray-600">
                      {template.translations?.mr?.title || "—"}
                    </td>
                    <td className="px-3 sm:px-4 py-3 text-sm text-gray-600">
                      {template.translations?.or?.title || "—"}
                    </td>
                    <td className="px-3 sm:px-4 py-3 text-sm text-gray-500 whitespace-nowrap">
                      {formatCreatedAt(template.created_at)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
